<a aria-label="open zipcode modal" role="button" href=javascript:void(0) class="dt-an-zipcode-popover-location" *ngIf="locateMeData"  (click)="open($event)">
  <span class="dt-an-zipcode-popover-location__icon" (mouseover)="showIcon = false" (mouseleave)="showIcon = true">
    <ng-container *ngIf="!blackStyle; else whiteStyle">
      <img *ngIf="showIcon" id="location-default" [src]="fixPath(locateMeData.Icon)" alt="Location Modal">
      <img *ngIf="!showIcon" id="location-default-hover" [src]="fixPath(locateMeData.IconHover)" alt="Location Modal">
    </ng-container>
    <ng-template #whiteStyle>
      <img *ngIf="showIcon" id="location-secondary" [src]="fixPath(locateMeData.SecondaryIcon)" alt="Location Modal">
      <img *ngIf="!showIcon" id="location-secondary-hover" [src]="fixPath(locateMeData.SecondaryIconHover)" alt="Location Modal">
    </ng-template>
  </span>

  <span class="dt-an-zipcode-popover-location__text"
    [ngStyle]="{'color': blackStyle ? '#0A3453' : '#fff'}"> {{ locateMeData.PreferredZipCode }} </span>
</a>

<div [ngClass]="{'dt-zipcode--popover': isPopover, 'dt-zipcode--modal': !isPopover}" role="dialog"
  aria-labelledby="zipcodeModal" *ngIf="configData && isOpened" (click)="onClickHandle($event)">

  <div class="dt-zipcode-arrow"></div>

  <div class="dt-zipcode__dialog" role="document">
    <div class="dt-zipcode__content">
      <dt-progress-bar></dt-progress-bar>
      <div class="dt-zipcode-form">
        <h2 class="dt-zipcode-form__text">
          {{ configData.SearchWithinTxt }}
        </h2>

        <form [formGroup]="zipcodeForm" (ngSubmit)="updateZipcode()">
          <div class="form-group dt-zipcode-form__input">
            <input type="text" maxlength="5" allowOnlyNumbers formControlName="zipcode" class="form-control" (focus)="focusInput()" [placeholder]="configData.ZipCodePlaceholder">
            <a href=javascript:void(0) class="dt-zipcode-form__location" (click)="getZipcode()">
              <div class="dt-zipcode-form__location--icon">
                <img [src]="configData.GetCurrentLocationIcon.Src" [alt]="">
              </div>
              <span class="dt-zipcode-form__location--text">
                {{ configData.GetCurrentLocationLabel }}
              </span>
            </a>
            <div class="dt-zipcode-form__invalid"> <span *ngIf="isInvalidZipcode"> {{ errorMessage }} </span> </div>
          </div>

          <button type="submit" class="primary-cta dt-zipcode-form__submit" [disabled]="zipcodeForm.invalid"> {{
            configData.SubmitCTATxt }} </button>
        </form>

      </div>
      <a class="dt-zipcode-close" (click)="close()" aria-label="close zipcode modal" role="button" href=javascript:void(0)>
        <img class="dt-zipcode-close__icon"
          src="data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2017%2017%22%3Ea%20%20%3Cdefs%3E%20%3Cstyle%3E.clsa%2C.clsc%7Bfill%3A%230A3453%3B%7D.clsa%7Bclip-rule%3Aevenodd%3B%7D.clsb%7Bclip-path%3Aurl%28%23clsa%29%3B%7D.clsd%7Bclip-path%3Aurl%28%23clsb%29%3B%7D%20%3C%2Fstyle%3E%20%3CclipPath%20id%3D%22clsa%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M1.495-16.278%2C17.722-.051l-.773.773L.722-15.505Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%3CclipPath%20id%3D%22clsb%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M16.949-16.278l.773.773L1.495.722.722-.051Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20transform%3D%22translate%28-0.722%2016.278%29%22%3E%20%3Cg%20class%3D%22clsb%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M2.151-23.349%2C26.105.605l-8.5%2C8.5L-6.349-14.849Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%3Cg%20class%3D%22clsd%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M17.605-23.349l8.5%2C8.5L2.151%2C9.105l-8.5-8.5Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%20%3C%2Fsvg%3E"
          type="image/svg+xml" alt="Close">
      </a>
    </div>
  </div>
</div>
